/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const containerStyle = {
  container: {
    paddingLeft: "1rem",
    paddingRight: "1rem",
    margin: "0 auto",
  },
  containerXs: {
    maxWidth: "45rem", // 720px
  },
  containerSm: {
    maxWidth: "55rem", // 880px
  },
  containerMd: {
    maxWidth: "69rem", // 1104px
  },
  containerLg: {
    maxWidth: "81rem", // 1296px
  },
  containerXl: {
    maxWidth: "90rem", // 1440px
  },
  verticalPadding: {
    paddingTop: "2rem",
    paddingBottom: "2rem",
  },
};

export default containerStyle;
